import { render, staticRenderFns } from "./formCaseStudy.vue?vue&type=template&id=2b89c5e7&scoped=true&"
import script from "./formCaseStudy.vue?vue&type=script&lang=js&"
export * from "./formCaseStudy.vue?vue&type=script&lang=js&"
import style0 from "./formCaseStudy.vue?vue&type=style&index=0&id=2b89c5e7&scoped=true&lang=css&"
import style1 from "./formCaseStudy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b89c5e7",
  null
  
)

export default component.exports